import { useState } from "react";
import { uploadMultipleFile } from "../services/uploadService";

export function useUploadFile() {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  const uploadMultiple = async (formData) => {
    try {
      setStatus("uploading");
      const response = await uploadMultipleFile(formData);

      setData(response.result);
      setStatus("done");
      return response.result; // ✅ return result for chaining
    } catch (err) {
      setError(err.message || "Upload failed");
      setStatus("error");
      throw err; // ✅ let caller handle error
    }
  };

  const resetUploadStatus = () => {
    setStatus("idle");
    setError(null);
    setData(null);
  };

  return { uploadMultiple, data, status, error, resetUploadStatus };
}
